import React from "react";
import { Link } from "react-router-dom";
import {
  Brain,
  HeartPulse,
  SmilePlus,
  Dna,
  Video,
  Globe,
  Biohazard,
  Radiation,
  Star,
  User,
  BookOpen,
  Stethoscope,
  PackageSearch,
} from "lucide-react";
import { banner_style } from "../Styles/styles";

const data = {
  event: {
    title: "About IDOM 2025",
    date: "12th Sep 2025",
    organizer: "Helix Conferences",
    description: [
      <>
        The International Conference on Dental and Oral Health, widely known as
        IDOM 2025, stands as a hallmark event within the World Dental Summit
        circuit. This annual gathering is dedicated to advancing excellence in
        Dentistry and Oral Medicine, bridging gaps between clinical practice,
        scientific Research, and patient care.
      </>,
      <>
        As a Globally recognized Dental Conference, IDOM 2025 provides a stage
        for Oral Healthcare Leaders to share breakthroughs in areas like
        restorative Dentistry, Oral Pathology, Dental technology, and
        preventive Medicine. The conference is not just a meeting, it's a
        movement toward better Health outcomes and Global collaboration. Explore
        our{" "}
        <Link
          to="#"
          target="blank"
          rel="noopener noreferrer"
          className="text-accent font-bold"
        >
          Oral Health Conferences
        </Link>{" "}
        to engage with dynamic sessions across the full dental value chain.
      </>,
    ],
  },

  whyAttend: [
    "Featured as a prominent Oral Medicine Conclave and listed among the top 2025 Dental Events, IDOM 2025 offers unmatched opportunities.",
    "Whether you're attending to present Research, expand your practice, or gain continuing education, the Oral Health Conference 2025 at IDOM 2025 promises unmatched value.",
  ],

  aboutHelix: [
    "Helix Conferences has earned international recognition for organizing premium pharma and healthcare events. We design our conferences with a focus on strategic insights, regulatory trends, and scientific breakthroughs to ensure attendees leave with real-world knowledge and partnerships.",
  ],

  whoShouldAttend: [
    "Pharma professionals and researchers",
    "Biotech and clinical R&D experts",
    "Regulatory affairs and compliance officers",
    "Academicians and industry consultants",
    "Students and early-career scientists in pharma",
  ],

  join: [
    "Join us to explore the future of Oral Health at IDOM 2025, the Global pulse of Dental excellence.",
  ],

  themes: [
    {
      icon: Brain,
      title: "Pharmacology",
      description:
        "Exploring Drug Action: Foundations and Frontiers in Pharmacology",
    },
    {
      icon: HeartPulse,
      title: "ceutics",
      description: "Innovations in Drug Formulation and Delivery Systems",
    },
    {
      icon: SmilePlus,
      title: "Pharmacognosy",
      description:
        "Natural Products and Herbal Drug Discovery in Modern Medicine",
    },
    {
      icon: Dna,
      title: "Pharmacovigilance",
      description:
        "Ensuring Drug Safety: Global Perspectives in Pharmacovigilance",
    },
    {
      icon: Video,
      title: "Pharma Regulatory Affairs",
      description:
        "Navigating Compliance: Regulatory Affairs in a Global Market",
    },
    {
      icon: Globe,
      title: "Traditional Medicine",
      description:
        "Integrating Ancient Wisdom with Modern Therapeutics",
    },
    {
      icon: Biohazard,
      title: "Pharma Chemistry",
      description:
        "Chemical Foundations of Drug Design and Synthesis",
    },
    {
      icon: Radiation,
      title: "Pharma Analysis",
      description:
        "Analytical Techniques in Pharmaceutical Quality Control",
    },
  ],

  highlights: [
  {
    title: "Keynote Speakers",
    description: "Expert-led Scientific sessions",
  },
  {
    title: "Panel Discussions",
    description: "Debates on Ethics and Policy",
  },
  {
    title: "Live Demonstrations",
    description: "Tools, equipment, AI in action",
  },
  {
    title: "Innovation Labs",
    description: "Hands-on with emerging Dental Tech",
  },
  {
    title: "Poster Presentations",
    description: "International Poster Presentations",
  },
  {
    title: "Workshops",
    description: "Hands-on Clinical Workshops",
  },
  {
    title: "Partnership Zones",
    description: "Collaboration and Networking across borders",
  },
  {
    title: "Awards & Recognition",
    description: "Honor excellence in Dental Innovation",
  },
],


  dates: {
    eventDate: "12th Sep 2025",
    venue: "Novotel Valencia, Spain",
    registrationDeadline: "1st Nov 2025",
  },
};


const AboutPublicHealth = () => {
  return (
    <div className="w-full 2xl:max-w-[1280px] mx-auto justify-center items-center text-center">
      <div className={`${banner_style} w-full mx-auto about-banner`}>
        <h1 className="text-slate-100 text-3xl sm:text-5xl md:text-6xl font-bold px-4 z-10">
          {data.event.title}
        </h1>
      </div>

      <h1 className="text-4xl mt-2 font-bold text-one">
      A WEBINAR ON IDOM-2025
      </h1>
      <p className="text-center text-gray-600 text-3xl mb-6">
        <strong>
          12<sup>th</sup> Sep 2025
        </strong>
      </p>

      {data.event.description.map((desc, idx) => (
        <p
          key={idx}
          className="mb-6 text-lg leading-relaxed text-center w-full min-w-5xl px:2 md:px-12 lg:px-24"
        >
          {desc}
        </p>
      ))}

      {/* Why Attend Section */}
      {/* <section className="mb-10 text-center w-full max-w-4xl">
        <h2 className="text-3xl font-bold text-one mb-4">Why Attend the 2025 Oral Medicine Conference?</h2>
        {data.whyAttend.map((para, idx) => (
          <p key={idx} className="mb-3 text-base text-gray-700 text-center w-full">
            {para}
          </p>
        ))}
      </section> */}

      {/* About Helix Section */}
      {/* <section className="mb-10 text-center w-full max-w-4xl">
        <h2 className="text-3xl font-bold text-one mb-4">Helix Conferences: Leading the Way in Event Organization</h2>
        {data.aboutHelix.map((para, idx) => (
          <p key={idx} className="mb-3 text-base text-gray-700 text-center w-full">
            {para}
          </p>
        ))}
      </section> */}

      {/* Who Should Attend Section */}
      {/* <section className="mb-10 text-center w-full max-w-4xl">
        <h2 className="text-3xl font-bold text-one mb-4">Who Can Attend?</h2>
        <ul className="list-disc list-inside text-base text-gray-700 text-center w-full">
          {data.whoShouldAttend.map((item, idx) => (
            <li key={idx} className="mb-2">{item}</li>
          ))}
        </ul>
      </section> */}

      {/* Join Section */}
      <section className="mb-10 text-center w-full min-w-4xl px-2 md:px-12 lg:px-24">
        <h2 className="text-3xl font-bold text-one mb-4 w-full">
          Join the Global Community at IDOM Conference 2025
        </h2>
        {data.join.map((para, idx) => (
          <p
            key={idx}
            className="mb-6 text-lg leading-relaxed text-center w-full min-w-5xl px:2 md:px-12 lg:px-24"
          >
            {para}
          </p>
        ))}
      </section>

      {/* Themes Section */}
      <section className="mb-16 text-center w-full px-12">
        <h2 className="text-4xl my-8 font-bold text-one">Who Can Attend...</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <User className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              IDOM Professionals
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <BookOpen className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Academics & Researchers
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <Stethoscope className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Healthcare Administrators
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <PackageSearch className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Healthcare product and Service providers
            </h3>
          </div>
          {/* <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <GraduationCap className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">Students and trainees in dentistry and related fields</h3>
          </div> */}
        </div>
      </section>

      {/* Highlights Section */}
      <section className="mb-16 text-center w-full px-12">
        <h2 className="text-4xl font-bold text-one mb-8">Event Highlights</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full items-start">
          {data.highlights.map((highlight, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-4 text-md text-gray-800 text-left flex items-start shadow-sm "
            >
              <Star className="w-4 h-4 text-yellow-500 fill-yellow-500 mr-3 mt-1" />
              <div className="flex flex-wrap items-start">
                <h3 className="font-semibold whitespace-nowrap mr-1">
                  {highlight.title} –
                </h3>
                <p className="text-md text-gray-600 flex-1">
                  {highlight.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Dates Section */}
      {/* <section className="mb-16 text-center w-full md:px-12 px-4">
        <h2 className="text-4xl font-bold text-one mb-8">
          Important Dates
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full text-sm">
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <Calendar className="w-6 h-6 text-one mb-2" />
            <strong>Event Date</strong>
            <p>{data.dates.eventDate}</p>
          </div>
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <Globe className="w-6 h-6 text-one mb-2" />
            <strong>Proposed Venue</strong>
            <p>{data.dates.venue}</p>
          </div>
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <BadgeCheck className="w-6 h-6 text-one mb-2" />
            <strong>Registration Deadline</strong>
            <p>{data.dates.registrationDeadline}</p>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default AboutPublicHealth;

